import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardCover,
  CardContent,
} from "@mui/joy"; // Importa componentes de Joy UI
import "../../css/mapboxaventuras.css";
import PlaceIcon from "@mui/icons-material/Place";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default function Mapa({ aventuras, longitud, latitud, zoom }) {
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  useEffect(() => {
    if (!mapRef.current && mapContainerRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [latitud, longitud],
        zoom: 0.5,
        projection: "globe",
      });
      mapRef.current.on("style.load", () => {
        mapRef.current.setFog({});
      });
    }
  }, []);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.flyTo({
        center: [longitud, latitud],
        essential: true,
        zoom: zoom,
      });
    }
  }, [latitud, longitud]);

  useEffect(() => {
    if (mapRef.current && aventuras) {
      aventuras.forEach((aventura) => {
        if (aventura.latitud && aventura.longitud) {
          // Crear el contenedor del popup con React
          const popupContent = document.createElement("div");

          // Componente del contenido del popup
          const PopupContent = () => (
            <Card
              sx={{
                minHeight: "120px",
                width: 220,
                boxShadow: 3,
                overflow: "hidden",
              }}
            >
              <CardCover>
                <img
                  src={`${linkimagen}/uploads/${aventura.imagen}`}
                  srcSet={`${linkimagen}/uploads/${aventura.imagen}`}
                  loading="lazy"
                  alt={aventura.titulo}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </CardCover>
              <CardCover
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 300px)",
                  zIndex: 1,
                }}
              />
              <CardContent
                sx={{
                  position: "relative",
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                <Typography
                  sx={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}
                  variant="subtitle1"
                >
                  {aventura.titulo}
                </Typography>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                    color: "neutral.300",
                  }}
                  startDecorator={<PlaceIcon />}
                >
                  {aventura.pais}
                </Typography>
              </CardContent>
            </Card>
          );

          // Renderizar el contenido del popup en el DOM
          ReactDOM.render(<PopupContent />, popupContent);

          // Agregar el marcador con el popup
          new mapboxgl.Marker()
            .setLngLat([aventura.longitud, aventura.latitud])
            .setPopup(new mapboxgl.Popup().setDOMContent(popupContent))
            .addTo(mapRef.current);
        }
      });
    }
  }, [aventuras]);

  return (
    <div
      ref={mapContainerRef}
      style={{
        width: "100%",
        height: "100%",
        borderRadius: "8px",
      }}
    />
  );
}
